/**
 * Skeleton de Cirurgias — header padrão + barra de abas (fila /
 * agendadas / realizadas / relatórios) + lista de cirurgias.
 */
export default function Loading() {
  return (
    <div className="mx-auto flex max-w-7xl animate-pulse flex-col gap-6">
      {/* PageHeader */}
      <div className="h-[104px] rounded-[20px] bg-slate-200" />

      {/* Abas */}
      <div className="flex items-center justify-between gap-3">
        <div className="h-11 w-80 rounded-xl border border-slate-200 bg-white" />
        <div className="h-11 w-40 rounded-xl bg-slate-200" />
      </div>

      {/* Lista de cirurgias */}
      <div className="divide-y divide-slate-100 rounded-xl border border-slate-200 bg-white">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="flex items-center gap-4 px-5 py-4">
            <div className="flex-1">
              <div className="h-4 w-56 rounded bg-slate-200" />
              <div className="mt-2 h-3 w-40 rounded bg-slate-100" />
            </div>
            <div className="h-6 w-20 rounded-full bg-slate-100" />
            <div className="hidden h-3 w-24 rounded bg-slate-100 sm:block" />
          </div>
        ))}
      </div>
    </div>
  );
}
